import { Stack, Text } from 'braid-design-system';
import type { FC } from 'react';

import { DescriptionList } from '../../DescriptionList';

interface ProfileDetailsProps {
  details: Array<{
    name: string;
    values: string[];
    showVerifiedIcon?: boolean;
  }>;
}

export const ProfileDetails: FC<ProfileDetailsProps> = ({ details }) => {
  const { nonEmptyNameValues, emptyNameValues } = details.reduce<{
    emptyNameValues: string[];
    nonEmptyNameValues: Array<{
      name: string;
      values: string[];
      showVerifiedIcon?: boolean;
    }>;
  }>(
    (acc, current) => {
      if (current.name) {
        acc.nonEmptyNameValues.push(current);
      } else {
        acc.emptyNameValues.push(current.values.join(', '));
      }

      return acc;
    },
    { emptyNameValues: [], nonEmptyNameValues: [] },
  );

  if (emptyNameValues.length > 0) {
    return (
      <Stack space={['medium', 'small']}>
        {emptyNameValues.map((values, index) => (
          <Text key={index} size="small">
            {values}
          </Text>
        ))}
        <DescriptionList details={nonEmptyNameValues} />
      </Stack>
    );
  }

  return <DescriptionList details={nonEmptyNameValues} />;
};
